getScreenTypeByPathInfo